import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import styles from './BrandInformation.module.css';

const BrandInformationMCC = () => {
    return (
      <Row className={styles.salesOptionsContainer}>
        <h1>
          Choice Creates More Opportunity
        </h1>
        <p>
          Mechanical Contractors' Choice (MCC) is an extended service agreement program 
          that delivers flexible labor coverage options for you
          and your customers. You can create more revenue opportunities
          by customizing the term and service reimbursement rate on
          every sale.
        </p>
      </Row>
    );
};

export default BrandInformationMCC;